<div class="row1">
  <div class="col-md-12">
    <mat-card appearance="outlined" class="card-widget" name="OngoingCard">
      <div class="padL8" style="display: flex">
        <h4 class="marTB24" name="Ongoing_Heading">
          <strong>Ongoing task</strong>
        </h4>
        <app-donut-chart
          [chartData]="onGoingChart"
          *ngIf="this.onGoingChart.centerText !== '0%'"
          name="Ongoing_chart"
          style="margin-top: 15px"
        >
        </app-donut-chart>
      </div>
      <mat-card-content id="task">
        <cdk-virtual-scroll-viewport itemSize="10" class="scroll-viewport">
          <div *ngIf="statusData.length === 0">
            <div class="col-md-4 offset-md-4 marB8" style="margin-top: 75px; margin-left: 80px">
              <h5 class="H5Header">
                <strong>No data available</strong>
              </h5>
            </div>
          </div>
          <div *ngIf="statusData.length > 0">
            <ul>
              <li *ngFor="let status of statusData; let i = index" class="parent">
                <div>
                  <mat-checkbox
                    class="padL8"
                    (click)="onClick(status)"
                    [class.checked]="status.status === 'Completed'"
                    [disabled]="true"
                    [checked]="status.status === 'Completed'"
                    name="sName+{{ i }}"
                  >
                    {{ status.name }}
                  </mat-checkbox>
                </div>

                <div style="display: inline" *ngIf="status.users">
                  <span *ngIf="status.users[0]" class="marL32 data-letters" name="User0">{{
                    status.users[0].name | initials
                  }}</span>
                  <span *ngIf="status.users[1]" class="data-letters" name="User1">{{
                    status.users[1].name | initials
                  }}</span>
                  <span *ngIf="status.users[2]" class="data-letters" name="User2">{{
                    status.users[2].name | initials
                  }}</span>
                  <span
                    *ngIf="status.users[3]"
                    class="marL16"
                    style="cursor: pointer"
                    id="pop"
                    (click)="showMore(status, $event)"
                    name="UserS"
                  >
                    {{ '+' + (status.users.length - 3) }}
                  </span>
                </div>
                <br />
              </li>
            </ul>
          </div>
        </cdk-virtual-scroll-viewport>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<div *ngIf="x && y">
  <div class="row">
    <div class="col-md-8">
      <mat-card appearance="outlined" class="bubbleShape child" [ngStyle]="x ? styleCard() : ''" name="User_Card">
        <div #styleCardref>
          <mat-card-content>
            <ul class="listItemSingle heightOverflow">
              <li *ngFor="let team of teamDataObjFiltered; let i = index">
                <span matRipple [matRippleColor]="ripcolor" class="clearfix mat-ripple">
                  <span class="listLeft">
                    <span class="data-letters float-left marR16">{{ team.name | initials }}</span>
                    <span class="marginicon40">
                      <h5 class="h5Header GreyDarkest" id="empName+{{ i }}">{{ team.name }}</h5>
                    </span>
                  </span>
                </span>
              </li>
            </ul>
          </mat-card-content>
        </div>
      </mat-card>
    </div>
  </div>
</div>
